export default __webpack_public_path__ + "crashes-module-empty-heading.png";